import Axios from "@/plugins/Axios";
import store from "@/store";
import Disciplina from "@/Models/Disciplina";

export class DisciplinasService {
  async syncAll() {
    const response = await Axios().get("disciplinas");
    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    store.commit("Disciplinas/setDisciplinas", disciplinas);
    return disciplinas;
  }

  async syncAllPaginated(pageNumber, query) {
    const response = await Axios().get(
      `disciplinas/disciplina-pages?page=${pageNumber}&query=${query}`
    );
    return response.data;
  }

  async criarDisciplina(disciplina) {
    const response = await Axios().post("disciplinas", disciplina);
    const novaDisciplina = response.data;
    store.commit("Disciplinas/adicionarDisciplina", novaDisciplina);
    return novaDisciplina;
  }

  async atualizarDisciplina(disciplina) {
    const response = await Axios().put(`disciplinas/${disciplina.id}`, disciplina);
    const disciplinaAtualizada = response.data;
    store.commit("Disciplinas/atualizarDisciplina", disciplinaAtualizada);
    return disciplinaAtualizada;
  }

  async deletarDisciplina(disciplina) {
    const response = await Axios().delete(`disciplinas/${disciplina.id}`);
    const disciplinaDeletada = response.data;
    store.commit("Disciplinas/deletarDisciplina", disciplina.id);
    return disciplinaDeletada;
  }

  async recuperarDisciplina(disciplina) {
    return this.atualizarDisciplina({ ...disciplina, deleted_at: null });
  }

  async listarDisciplinas(gestao_id) {
    const response = await Axios().get(`disciplinas/listar/${gestao_id}`);
    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    return disciplinas;
  }

  async listarDisciplinasAEE() {
    const response = await Axios().get("disciplinas/educacao-inclusiva");
    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    // console.log(disciplinas);
    store.commit("Disciplinas/setDisciplinas", disciplinas);
    return disciplinas;
  }
}
export default new DisciplinasService();
